export default __webpack_public_path__ + "a5c87f147058df1ce7cba46e52ea286f.png";